import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { EmrCheckboxGroupComponent } from "../../../../shared/emr-checkbox-group/emr-checkbox-group.component";
import { EmrCheckboxComponent } from "../../../../shared/emr-checkbox/emr-checkbox.component";
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { NeurologicalFormGroup } from 'src/app/calvin-emr-shared/models/assessments/neurological.model';
import { FormOption } from 'src/app/shared/models/form-option.model';
import { WnlGroupDirective } from '../wnl/wnl-group.directive';
import { WnlControlDirective } from '../wnl/wnl-control.directive';

@Component({
  selector: 'app-neurological-form',
  templateUrl: './neurological-form.component.html',
  styleUrls: ['./neurological-form.component.scss', '../assessments-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrInputComponent,
    EmrCheckboxGroupComponent,
    EmrCheckboxComponent,
    WnlGroupDirective,
    WnlControlDirective,
  ],
})
export class NeurologicalFormComponent {
  formGroup = input.required<NeurologicalFormGroup>();
  patient = input.required<Patient>();

  reset() {
    this.formGroup().enable({ emitEvent: false });
  }

  get abnormalReflexes() {
    return !!this.formGroup().controls.abnormalReflexesPresent.value;
  }

  extremityStrengthOptions = [
    new FormOption('Moderate'),
    new FormOption('Weak'),
    new FormOption('WNL'),
  ];

  sensationOptions = [
    new FormOption('Numbness'),
    new FormOption('Tingling'),
    new FormOption('Full sensation'),
  ];

  tremorsOptions = [
    new FormOption('RUE', 'rue'),
    new FormOption('RLE', 'rle'),
    new FormOption('LLE', 'lle'),
    new FormOption('LUE', 'lue'),
  ];

  abnormalReflexesOptions = [
    new FormOption('Jittery'),
    new FormOption('Absent'),
    new FormOption('Diminished'),
    new FormOption('Other'),
  ];
}
